import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, AppBar, Toolbar, IconButton, Typography, TextField, FormControlLabel, Radio, RadioGroup, CircularProgress } from '@material-ui/core'
import { show, update, store, change, success as changeSuccess } from '../../../store/actions/cotas.action'
import { changeScreenB } from '../../../store/actions/navigation.action'
import { changeAlert } from '../../../store/actions/alert.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaSave } from 'react-icons/fa'
import MaskedInput from 'react-text-mask' 

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'int') {
        mask = [/[0-9]/, /\d/]
    }

    if (props.name === 'qtd') {
        mask = [/[0-9]/, /\d/, /\d/]
    }

    if (props.name === 'def') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    }

    if (props.name === 'perc') {
        mask = [/[0-9]/, '.', /\d/, /\d/, /\d/]

        if (other.value) {
            let valid = other.value.replace('.', '')
            if (valid.length > 3) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/]
            }
        }
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

export default function CotaPremiadaEdit(props) {
    const dispatch = useDispatch()
    const { cota, error } = useSelector(state => state.cotasReducer)
    const editor = (props.editor) ? props.editor : null
    const campaign_id = (props.campaign_id) ? props.campaign_id : null
    const id = (props.uid) ? props.uid : null;
    const [qtd, setQtd] = React.useState(1)
    const [isLoading, setLoading] = React.useState(true)
    const [aleatorio, setAleatorio] = React.useState(1)

    React.useEffect(() => {
        _index()
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _index = () => {
        if (id) {
            dispatch(show(id)).then(() => setLoading(false))
        } else {
            dispatch(change('clear'))
            setLoading(false)
        }
    }

    const _save = () => {
        if(id) {
            dispatch(update({
                'id' : id,
                'campaign_id' : campaign_id,
                'title' : cota.title,
                'percent' : document.getElementById('percent') ? document.getElementById('percent').value : null,
                'min_amount' : document.getElementById('min_amount') ? document.getElementById('min_amount').value : null,
                'max_amount' : document.getElementById('max_amount') ? document.getElementById('max_amount').value : null
            }, editor))
        } else {
            dispatch(store({
                'qtd' : (aleatorio === 2) ? 1 : qtd,
                'campaign_id' : campaign_id,
                'title' : cota.title,
                'percent' : document.getElementById('percent') ? document.getElementById('percent').value : null,
                'cota' : (aleatorio === 2) ? cota.cota : null
            }, editor))
        }
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreenB({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        {(id) ? 'Editar Cota' : 'Nova Cota'}
                    </Typography>

                    <Button 
                        variant="contained" 
                        size="small"
                        onClick={() => _save()}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSave />}
                    >
                        Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
            <>
                
                
                {(!id) &&
                    <div className="card card-body bs-bg">
                        <RadioGroup
                            row
                            name="aleatorio"
                            value={aleatorio}
                            onChange={text => {
                                if(parseInt(text.target.value) === 2) {
                                    setQtd(1)
                                }
                                setAleatorio(parseInt(text.target.value))
                            }}
                            className="fw-bold bs-color-b"
                        >
                            <FormControlLabel value={1} control={<Radio color="primary" />} label="Aleatória" />
                            <FormControlLabel value={2} control={<Radio color="primary" />} label="Cota Pré Definida" />
                        </RadioGroup>
                    </div>
                }

                <div className="card card-body mt-2 bs-bg">
                    {id ?
                        <div className="mb-3">
                            <small className="d-block bs-color">Cota</small>
                            <h3 className="fw-bold bs-color-b">{cota.quota_number}</h3>
                        </div>
                    :
                    <>
                        {aleatorio === 1 &&
                            <div className="mb-3">
                                <label className="label-custom d-block bs-color-b">Quantidade de Cotas</label>
                                <TextField
                                    name="qtd"
                                    type="tel"
                                    InputProps={{
                                        inputComponent: TextMaskCustom,
                                        value: qtd,
                                        placeholder: '1',
                                        onChange: e => setQtd(e.target.value ? parseInt(e.target.value) : e.target.value)
                                    }}
                                />
                            </div>
                        }
                    </>
                    }

                    {(qtd === 1 && aleatorio === 2 && !id) &&
                        <div className="mb-3">
                            <label className="label-custom d-block bs-color-b">Número da Cota</label>
                            {id ?
                                <button type="button" className="btn btn-success rounded-0">
                                    {cota.cota}
                                </button>
                            :
                                <TextField
                                    name="def"
                                    type="tel"
                                    disabled={(id) && true}
                                    InputProps={{
                                        inputComponent: TextMaskCustom,
                                        value: cota.cota,
                                        placeholder: 'Ex: 777777',
                                        onChange: text => dispatch(change({ cota: text.target.value }))
                                    }}
                                />
                            }
                        </div>
                    }

                    <div className="mb-5">
                        <label className="label-custom bs-color-b">Prêmio</label>
                        <TextField
                            error={(error.title) && true}
                            value={cota.title || ''}
                            placeholder="Ex: R$ 5.000"
                            onChange={text => dispatch(change({ title: text.target.value }))}
                        />
                    </div>

                    {(qtd === 1 && aleatorio === 1) &&
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Porcentagem</label>
                            <TextField
                                id="percent"
                                name="perc"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: cota.percent > 0 ? String(cota.percent) : '',
                                    placeholder: 'ex: 70.05',
                                    onChange: text => dispatch(change({ percent: text.target.value }))
                                }}
                            />
                        </div>
                    }

                    {(id) &&
                        <>
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Valor Minimo</label>
                            <TextField
                                id="min_amount"
                                name="int"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: cota.min_amount > 0 ? cota.min_amount : '',
                                    placeholder: 'ex: 20',
                                    onChange: text => {
                                        if(text.target.value > 50) {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Limite maximo até 50 reais',
                                                class: 'error'
                                            }))
                                            dispatch(change({ min_amount: '' }))
                                        } else {
                                            dispatch(change({ 
                                                min_amount: text.target.value,
                                                max_amount: null
                                            }))
                                        }
                                    }
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Valor Máximo</label>
                            <TextField
                                id="max_amount"
                                name="int"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: cota.max_amount > 0 ? cota.max_amount : '',
                                    placeholder: 'ex: 20',
                                    onChange: text => {
                                        if(text.target.value > 50) {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Limite maximo até 50 reais',
                                                class: 'error'
                                            }))
                                            dispatch(change({ max_amount: '' }))
                                        } else {
                                            dispatch(change({ 
                                                min_amount: null,
                                                max_amount: text.target.value 
                                            }))
                                        }
                                    }
                                }}
                            />
                        </div>
                        </>
                    }

                    <div className="mb-3">
                        <div className="alert alert-success mt-3" role="alert">
                            <strong>Vazio:</strong> A Cota fica livre e pode sair a qualquer momento de forma aleatória 
                        </div>
                        <div className="alert alert-warning mt-3" role="alert">
                            <strong>Definida:</strong> A Cota só fica livre após a ação chegar na porcentagem definida.
                        </div>
                        <div className="alert alert-secondary mt-3" role="alert">
                            <strong>Limite:</strong> A Cota só pode ser travada de 1 a 99 por cento da ação.
                        </div>
                    </div> 
                </div>
            </>
            }
            </div>
        </>
    )
}